// @ts-check

import { BillingSessionInvoiceModel, IBillingSessionInvoice, BillingSessionCustomerModel, IBillingSessionCustomer } from "@core/models";
import { BILLING_SESSIONS_INVOICE_STATUS } from "@core/constants";

export const invoiceToCreate = new BillingSessionInvoiceModel({
  [IBillingSessionInvoice.hours]: "35h00",
  [IBillingSessionInvoice.excludingTaxAmount]: 100,
  [IBillingSessionInvoice.includingTaxAmount]: 120,
  [IBillingSessionInvoice.statusCode]: BILLING_SESSIONS_INVOICE_STATUS.BILLABLE.code,
  [IBillingSessionInvoice.customer]: new BillingSessionCustomerModel({
    [IBillingSessionCustomer.id]: 8518653,
    [IBillingSessionCustomer.firstname]: "Marc",
    [IBillingSessionCustomer.lastname]: "Ball",
    [IBillingSessionCustomer.company]: "La maison Jess",
    [IBillingSessionCustomer.boLink]: "https://bo-dev.extracadabra.com/#/dashboard/etab/8518654",
    [IBillingSessionCustomer.stripeLink]: "https://dashboard.stripe.com/test/customers/cus_NxBgmcagTcLC11",
  }),
});

export const invoiceToValidate = new BillingSessionInvoiceModel({
  [IBillingSessionInvoice.hours]: "35h00",
  [IBillingSessionInvoice.excludingTaxAmount]: 100,
  [IBillingSessionInvoice.includingTaxAmount]: 120,
  [IBillingSessionInvoice.statusCode]: BILLING_SESSIONS_INVOICE_STATUS.TO_VALIDATE.code,
  [IBillingSessionInvoice.customer]: new BillingSessionCustomerModel({
    [IBillingSessionCustomer.id]: 8518654,
    [IBillingSessionCustomer.firstname]: "Henry",
    [IBillingSessionCustomer.lastname]: "Fontaine",
    [IBillingSessionCustomer.company]: "Café de la gare",
    [IBillingSessionCustomer.boLink]: "https://bo-dev.extracadabra.com/#/dashboard/etab/8518654",
    [IBillingSessionCustomer.stripeLink]: "https://dashboard.stripe.com/test/customers/cus_NxBgmcagTcLC11",
  }),
});

export const invoiceToPay = new BillingSessionInvoiceModel({
  [IBillingSessionInvoice.hours]: "35h00",
  [IBillingSessionInvoice.excludingTaxAmount]: 100,
  [IBillingSessionInvoice.includingTaxAmount]: 120,
  [IBillingSessionInvoice.statusCode]: BILLING_SESSIONS_INVOICE_STATUS.TO_PAY.code,
  [IBillingSessionInvoice.invoiceNumber]: "in_1PtQ5tAoopeIlK3U7eliJKx9",
  [IBillingSessionInvoice.customer]: new BillingSessionCustomerModel({
    [IBillingSessionCustomer.id]: 8518655,
    [IBillingSessionCustomer.firstname]: "Pascal",
    [IBillingSessionCustomer.lastname]: "Dupont",
    [IBillingSessionCustomer.company]: "Café de la gare",
    [IBillingSessionCustomer.boLink]: "https://bo-dev.extracadabra.com/#/dashboard/etab/8518655",
    [IBillingSessionCustomer.stripeLink]: "https://dashboard.stripe.com/test/customers/cus_NxBgmcagTcLC11",
  }),
});

export const invoiceToPaid = new BillingSessionInvoiceModel({
  [IBillingSessionInvoice.hours]: "35h00",
  [IBillingSessionInvoice.excludingTaxAmount]: 100,
  [IBillingSessionInvoice.includingTaxAmount]: 120,
  [IBillingSessionInvoice.statusCode]: BILLING_SESSIONS_INVOICE_STATUS.PAYED.code,
  [IBillingSessionInvoice.invoiceNumber]: "in_1PtQ5tAoopeIlK3U7eliJKx9",
  [IBillingSessionInvoice.customer]: new BillingSessionCustomerModel({
    [IBillingSessionCustomer.id]: 8518657,
    [IBillingSessionCustomer.firstname]: "Pascal",
    [IBillingSessionCustomer.lastname]: "Dupont",
    [IBillingSessionCustomer.company]: "Patisserie land",
    [IBillingSessionCustomer.boLink]: "https://bo-dev.extracadabra.com/#/dashboard/etab/8518655",
    [IBillingSessionCustomer.stripeLink]: "https://dashboard.stripe.com/test/customers/cus_NxBgmcagTcLC11",
  }),
});

export const allEtabInvoices = [invoiceToValidate, invoiceToPay, invoiceToCreate, invoiceToPaid];

export const EtabBillingSessionListMocks = {
  total: allEtabInvoices.length,
  data: allEtabInvoices,
};

export const allInvoicesSelectionMocks = allEtabInvoices.map((invoice) => {
  return {
    id: invoice.getCustomer().getId(),
    status: invoice.getStatus().code,
    invoice_number: invoice.getInvoiceNumber(),
  };
});
